import React from 'react';

import { Loader } from 'js/components/common/Loader';

import style from './PageLoader.scss';

export const PageLoader = () => (
    <div className={style.wrapper}>
        <Loader />
    </div>
);
